import { z } from "zod";

export const RegistrationPeriodStatsSchema = z.object({
  date: z.string(),
  count: z.number(),
});

export type RegistrationPeriodStats = z.infer<
  typeof RegistrationPeriodStatsSchema
>;

export const RegistrationStatsResponseSchema = z.object({
  totalMembers: z.number(),
  stats: z.array(RegistrationPeriodStatsSchema),
  period: z.string(),
});

export type RegistrationStatsResponse = z.infer<
  typeof RegistrationStatsResponseSchema
>;

export const VisitorStatsResponseSchema = z.object({
  totalVisitors: z.number(),
  stats: z.array(RegistrationPeriodStatsSchema),
  period: z.string(),
});

export type VisitorStatsResponse = z.infer<typeof VisitorStatsResponseSchema>;

export const VisitorPeriodStatsSchema = z.object({
  date: z.string(),
  count: z.number(),
});

export type VisitorPeriodStats = z.infer<typeof VisitorPeriodStatsSchema>;

export const OrderPeriodStatsSchema = z.object({
  date: z.string(),
  count: z.number(),
});

export type OrderPeriodStats = z.infer<typeof OrderPeriodStatsSchema>;

export const OrderStatsResponseSchema = z.object({
  totalOrders: z.number(),
  stats: z.array(OrderPeriodStatsSchema),
  period: z.string(),
});

export type OrderStatsResponse = z.infer<typeof OrderStatsResponseSchema>;

export const PaymentPeriodStatsSchema = z.object({
  date: z.string(),
  amount: z.number(),
});

export type PaymentPeriodStats = z.infer<typeof PaymentPeriodStatsSchema>;

export const PaymentStatsResponseSchema = z.object({
  totalAmount: z.number(),
  stats: z.array(PaymentPeriodStatsSchema),
  period: z.string(),
});

export type PaymentStatsResponse = z.infer<typeof PaymentStatsResponseSchema>;

/** 주문관리 검색 조건(키워드·기간·상태)과 같은 범위의 업체별·종목별 주문금액 요약 */
export const OrderAmountSummarySchema = z.object({
  timezone: z.literal("Asia/Seoul"),
  legacyDateCount: z.number(),
  totalAmount: z.number(),
  totalOrders: z.number(),
  customers: z.array(z.object({
    customerId: z.number(), customerName: z.string(), orderCount: z.number(), amount: z.number(),
  })),
  categories: z.array(z.object({
    categoryId: z.number().nullable(), categoryName: z.string(), orderCount: z.number(), amount: z.number(),
  })),
});
export type OrderAmountSummaryResponse = z.infer<typeof OrderAmountSummarySchema>;
export type OrderAmountSummaryQuery = { status?: string; keyword?: string; dateFrom?: string; dateTo?: string };

